import { Component, inject, input, output, signal, computed } from '@angular/core';
import { NzImageModule } from 'ng-zorro-antd/image';
import { Marker } from '../../../models/classes/marker';
import { UiService } from '../../../services/ui.service';
import { I18nService } from '../../../services/i18n.service';
import { GLOBAL_CONSTANT } from '../../../constants/global.constant';

@Component({
  selector: 'app-header-marker-image',
  imports: [NzImageModule],
  templateUrl: './header-marker-image.html',
  styleUrls: ['./header-marker-image.scss'],
})
export class HeaderMarkerImageComponent {
  image = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  useDefaultImage = input<boolean>(false);
  defaultImage = input<string>('assets/images/default_image_sensor.png');
  markers = input<Marker[]>([]);

  imageLoaded = output<Event>();

  private ui = inject(UiService);
  public i18n = inject(I18nService);

  clientWidth = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  clientHeight = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  imageWidth = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  imageHeight = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);

  isMobile = computed(() => this.ui.IsMobile());
  isTablet = computed(() => this.ui.IsTablet());
  isDesktop = computed(() => this.ui.IsDesktop());

  // Effective image source based on useDefaultImage + provided image
  effectiveSrc = computed<string>(() => {
    const useFallback = this.useDefaultImage();
    return useFallback ? this.defaultImage() : this.image() || this.defaultImage();
  });

  onImageLoaded(event: Event): void {
    this.imageLoaded.emit(event);
    const el = event?.target as HTMLImageElement | null;
    if (!el) return;

    this.clientWidth.set(el.clientWidth);
    this.clientHeight.set(el.clientHeight);
    this.imageWidth.set(el.naturalWidth);
    this.imageHeight.set(el.naturalHeight);
  }
}
